'use client'
import { ChainEnum } from '@dynamic-labs/sdk-api-core';

const findPrimaryEmbeddedChain = (projectSettings) => {
    var _a, _b, _c;
    const embeddedChainConfig = ((_b = (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _a === void 0 ? void 0 : _a.embeddedWallets) === null || _b === void 0 ? void 0 : _b.chainConfigurations) || [];
    return ((_c = embeddedChainConfig.find((chain) => chain.primary)) === null || _c === void 0 ? void 0 : _c.name) === 'SOL'
        ? ChainEnum.Sol
        : ChainEnum.Evm;
};

export { findPrimaryEmbeddedChain };
